<form class="modal-body" [formGroup]="form" (ngSubmit)="submit()" novalidate>
  <p class="centermodal__title">Open Graph</p>
  <div>
    <div class="centermodal__group"></div>
    <p class="centermodal__group-title">{{ 'whitelabel.imageLink' | translate }}</p>
    <div [ngbTooltip]="tooltipOpengraph" triggers="mouseenter:mouseleave" #toggleTooltipOpengraph="ngbTooltip" placement="left">
      <label [loadingAnimation]="isLoading" class="field__holder full mb-0" [appFormControlWrap]="form.get('url')">
        <input
          type="text"
          class="field"
          formControlName="url"
          autocomplete="off"
          autocorrect="off"
          spellcheck="false"
          autocapitalize="off"
          minlength="10"
          [disabled]="isLoading || !currentUser?.subscription.has_premium_features"
        />
        <span class="field__placeholder">{{ 'whitelabel.imageUrl' | translate }}</span>
      </label>
    </div>

    <p class="centermodal__group-title mt-4">{{ 'whitelabel.metaData' | translate }}</p>
    <label [loadingAnimation]="isLoading" class="field__holder full mb-0" [appFormControlWrap]="form.get('title')">
      <input
        type="text"
        class="field"
        [class.active]=""
        formControlName="title"
        autocomplete="none"
        autocorrect="off"
        appSpecialPattern
        spellcheck="false"
        autocapitalize="off"
        maxlength="60"
        [disabled]="isLoading || !currentUser?.subscription.has_premium_features"
      />
      <span class="field__placeholder">{{ 'whitelabel.title' | translate }}</span>
    </label>
    <div class="mt-2"></div>
    <label [loadingAnimation]="isLoading" class="field__holder full mb-0" [appFormControlWrap]="form.get('description')">
      <input
        type="text"
        class="field"
        [class.active]=""
        formControlName="description"
        autocomplete="none"
        autocorrect="off"
        appSpecialPattern
        spellcheck="false"
        maxlength="110"
        autocapitalize="off"
        [disabled]="isLoading || !currentUser?.subscription.has_premium_features"
      />
      <span class="field__placeholder">{{ 'whitelabel.description' | translate }}</span>
    </label>
  </div>
  <div class="centermodal__button-group mt-4">
    <button type="button" class="btn-L btn-filled-cancel" (click)="cancel()">{{ 'button.cancel' | translate }}</button>
    <button type="submit" class="btn-L btn-filled" [disabled]="isLoading">{{ 'button.save' | translate }}</button>
  </div>
</form>

<ng-template #tooltipOpengraph>
  <div class="tooltip__title">{{ 'whitelabel.imageLink' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'whitelabel.tooltipOpengraph' | translate }}
  </div>
</ng-template>
